import React,{useEffect} from 'react'
import {Route, Redirect} from 'react-router-dom'
import {connect} from 'react-redux'
import {loadUser} from '../store/authActions';

const PrivateRoute = ({component: Component, ...rest}) => {
  const {token,isAuthenticated, loading, loadUser} = rest
  useEffect(()=>{
    if(token) loadUser();
  //eslint-disable-next-line
  },[]);
  return (
    <Route
      {...rest}
      render={props => (
        !isAuthenticated && loading ? 
          (<Redirect to='/' />) :
          (<Component {...props} />)
      )}
    />
  )
}

const mapStoreToProps = state =>({
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading
})

export default connect(mapStoreToProps,{loadUser})(PrivateRoute)
